import React from 'react';

const SectionHeading = ({ title, subtitle, className = '', light = false }) => {
    return (
        <div className={`text-center max-w-2xl mx-auto mb-16 ${className}`}>
            {subtitle && (
                <span className={`${light ? 'text-gray-200' : 'text-purple-600'} font-bold tracking-widest text-xs uppercase mb-2 block`}>
                    {subtitle}
                </span>
            )}
            <h2 className={`serif text-4xl lg:text-5xl mb-4 ${light ? 'text-white' : 'text-gray-900'}`}>
                {title}
            </h2>
            <div className={`h-1 w-20 mx-auto ${light ? 'bg-purple-800' : 'bg-purple-200'}`}></div>
        </div>
    );
};

export default SectionHeading;
